export enum RepeatInterval {
	NEVER = 'never',
	EVERY_WORKING_DAY = 'everyWorkingDay',
	EVERY_WEEK = 'everyWeek',
	EVERY_MONTH = 'everyMonth',
	SPECIFIC_DAYS_IN_WEEK = 'specificDaysInWeek',
	EVERY_FORTNIGHT = 'everyFortnight',
}
